// components/ArticleComponent.js
import React from "react";
import { useNavigate } from "react-router-dom";
import "./Actualite.css";

const ArticleComponent = ({ articles, onArticleClick }) => {
  const navigate = useNavigate();

  const handleClick = (article) => {
    if (onArticleClick) {
      onArticleClick(article);
    } else {
      navigate(`/blog/${article.slug}`);
    }
  };

  if (!articles || articles.length === 0) {
    return (
      <div style={{ textAlign: "center", padding: "3rem", color: "#666" }}>
        Aucun article disponible
      </div>
    );
  }

  // Grouper les articles en paires pour les lignes
  const groupArticles = () => {
    const groups = [];
    for (let i = 0; i < articles.length; i += 2) {
      groups.push(articles.slice(i, i + 2));
    }
    return groups;
  };

  const articleGroups = groupArticles();

  return (
    <div className="content-list-article">
      {articleGroups.map((group, groupIndex) => (
        <div key={groupIndex} className="articles-row">
          {group.map((article, index) => (
            <div
              key={article.id || index}
              className="one-article"
              onClick={() => handleClick(article)}
              style={{ cursor: "pointer" }}
            >
              <div className="left-content">
                <span className="top-content">{article.category} | {article.date}</span>
                <div className="between-content">
                  <h3 className="name-descr">{article.title}</h3>
                </div>
                <span className="bottom-content">Lire la suite</span>
              </div>
              <div className="right-content">
                <img
                  src={article.image}
                  alt={article.alt || article.title}
                  onError={(e) => {
                    e.target.src = "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR8bikI-KUuM1IWosgqDRS5jyv2U_PPYlG6Tg&s";
                  }}
                />
              </div>
            </div>
          ))}
          {/* Si le groupe n'a qu'un seul article, ajouter un div vide pour maintenir la structure */}
          {group.length === 1 && <div className="one-article" style={{ visibility: "hidden" }}></div>}
        </div>
      ))}
    </div>
  );
};

export default ArticleComponent;